module.exports = __webpack_public_path__ + "assets/img/email-80e54068.png";